// 날짜 입력 공용 컴포넌트 — 브라우저 기본 날짜 픽커(TextField type="date") 대체.
// 기존 호출부와 동일하게 "YYYY-MM-DD" 문자열 value/onChange를 주고받는다.
import React from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";

function PianoDay(props) {
  const isSunday = props.day.day() === 0;
  return (
    <PickersDay
      {...props}
      sx={{
        ...(isSunday && !props.selected && !props.outsideCurrentMonth ? { color: "#B0413E" } : {}),
        "&.MuiPickersDay-today": { border: "1.5px solid", borderColor: "secondary.main" },
      }}
    />
  );
}

export default function DateField({
  value,
  onChange,
  label,
  size,
  fullWidth,
  disabled,
  required,
  helperText,
  sx,
  disablePast,
  minDate,
  maxDate,
}) {
  return (
    <DatePicker
      label={label}
      format="YYYY-MM-DD"
      value={value ? dayjs(value) : null}
      onChange={(v) => onChange(v && v.isValid() ? v.format("YYYY-MM-DD") : "")}
      disabled={disabled}
      disablePast={disablePast}
      minDate={minDate ? dayjs(minDate) : undefined}
      maxDate={maxDate ? dayjs(maxDate) : undefined}
      slots={{ day: PianoDay }}
      slotProps={{
        textField: { size, fullWidth, required, helperText, sx },
        actionBar: { actions: ["today"] },
        calendarHeader: { format: "YYYY년 M월" },
      }}
    />
  );
}
